export default __webpack_public_path__ + "7d8db3cc1113e75c21005ac63d6e8d44.png";